/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:20
 * @LastEditTime: 2019-10-22 17:18:55
 * @LastEditors: Please set LastEditors
 */
import axios from "axios";
import qs from "qs";
axios.defaults.timeout = 500000;
axios.defaults.withCredentials = true;
//http request 拦截器

axios.interceptors.request.use(
  (config) => {
    config.data = qs.stringify(config.data);
    config.headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      accept: "application/json",
    };
    // localStorage.setItem(
    //   "access_tokens",
    //   "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjQ2NjI3MTk3OGIxMzc5NTNmZWJjYzljOThmNjA4NDA0MTJkMDA3Njg5ZDFiNDgzYjAyMjNhOTA3MzcyM2ExYzI3YzA2ODQ4N2E3NmYwMjc0In0.eyJhdWQiOiIxMDA4ODAwMyIsImp0aSI6IjQ2NjI3MTk3OGIxMzc5NTNmZWJjYzljOThmNjA4NDA0MTJkMDA3Njg5ZDFiNDgzYjAyMjNhOTA3MzcyM2ExYzI3YzA2ODQ4N2E3NmYwMjc0IiwiaWF0IjoxNzY5NjcwMDkxLCJuYmYiOjE3Njk2NzAwOTEsImV4cCI6MTc3MDk2NjA5MSwic3ViIjoiOTMiLCJzY29wZXMiOlsiKiJdfQ.e8ZX5NZAbVMITljCzWYQo7uOdYT9-wPp8d6tIDXSxLu60kjp7wtYSEHYfu-3paMJnhIslipLM6yzgfGOltYynk8bS3cgv1nxP8VVwTfkwvwUSt32BtRfF4799zlnIpraGTG5SmD4kpG0L3J00e_C1W2FibK4P1EgiJbVFyGYu2zCaqDfo9B5pB6oDBmLHxQcoF2XnkEdd2Rf21YmEs_pXw-btlZtwiDUxFHlddcpExwHDlNYLNTVI4wxDG73sfF0rMz7mIzr2wGz1hjtK-24NQyeEL5vekJpdI1gCODejBasrtOsayEYSAPkDt3FbRbEnvkqstaOkNxsWk_0n9JwEEcwgDQHUTNQC18EvLFTbpjJGQ_i4nntPLB35esnz-aWq9Nx5UgqopeJBg5zv7ExNbgjqX44gLqoPZ2-8jhCfg_aX7E_Mya9TDmTQOMSJMNn_H3pu2CmUVhyWUdEYdMl4Ta9z5awuIpDUdi4ctmpHMDAxjn3JtV80i-C7ViyzXy5C6K3uMMj6Erlhb8zy-IDM7CYM3e4P_TY5ymvOY1ArbK69Y9pI9oFEhgry9uCVnB4IBMQfVBu30s5XATweaC5W7ioN21hGdGyNV1AHuPToJCmXsJT_wu4ob_7f96PCAHXb9HkcUBzNOV8ErUX-kBQBi-3SBMTv_o2_FnN_zgiGGg"
    // );
    config.headers.Authorization =
      "Bearer" + " " + localStorage.getItem("access_tokens");
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//http response 拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.data.code == 100) {
      location.href = location.href.split("#/")[0] + "#/login"; //跳回登陆页面
    }
    return response;
  },
  (error) => {
    if (error.data) {
      return Promise.reject(error.data);
    } else {
      return Promise.reject(error.response.data);
    }
  }
);

//定义全局的api
let api;

if (process.env.VUE_APP_type == "development") {
  api = {
    logistics: "http://logistics.com:8088/admin/v2",
    logistics_2: "http://pps.qwe.com/index.php/",
    pda: "http://logistics.com:8088/pda/v2/",
  };
} else if (process.env.VUE_APP_type == "production") {
  api = {
    logistics: "https://logistics.tx315.vip/admin/v2",
    logistics_2: "https://pps.tx315.vip/index.php/",
    pda: "https://logistics.tx315.vip/pda/v2/",
  };
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch(module, url, params = {}) {
  let baseUrl = "";
  if (module == "logistics") {
    baseUrl = api.logistics + url;
  } else if (module == "logistics_2") {
    baseUrl = api.logistics_2 + url;
  } else if (module == "pda") {
    baseUrl = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function del(module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.delete(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
